import React, { useState, useEffect } from "react";
import { axiosSalary } from "../api/axiosInstance";
import { useAuth } from "../auth/AuthContext";

const UnfinalizeAttendance = ({ open, onClose, rowData, onSuccess }) => {

  const { user } = useAuth();
  const [reason, setReason] = useState("");

  /* ================= RESET ================= */
  useEffect(() => {
    if (open) setReason("");
  }, [open]);

  /* ================= DATE FORMAT ================= */
  const formatDate = (dateStr) => {
    const [dd, mm, yyyy] = dateStr.split("/");
    return `${yyyy}-${mm}-${dd}`;
  };

  /* ================= SUBMIT ================= */
  const handleUnfinalize = async () => {
    try {
      const payload = {
        groupId: user?.groupId,
        restId: rowData.restId,
        empId: rowData.empId,
        attendanceDate: formatDate(rowData.attendanceDate),
        userId: user?.userId,
        reason: reason
      };

      await axiosSalary.post(
        "/DailyAttendance/UnfinalizeAttendance",
        payload
      );

      alert("Attendance unfinalized successfully");

      onClose();
      onSuccess && onSuccess();

    } catch (err) {
      console.error("Unfinalize error:", err);
      alert("Failed to unfinalize attendance");
    }
  };

  if (!open || !rowData) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">

      <div className="bg-white rounded-lg p-4 w-[320px]">

        <h3 className="font-semibold mb-2">
          Unfinalize Attendance - {rowData?.empName}
        </h3>

        <p className="text-xs text-gray-500 mb-2">
          This will reopen attendance for editing.
        </p>

        <textarea
          placeholder="Reason (optional)"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          className="w-full border p-2 rounded text-sm"
        />

        <div className="flex justify-end gap-2 mt-3">

          <button
            onClick={onClose}
            className="px-3 py-1 border rounded"
          >
            Cancel
          </button>

          <button
            onClick={handleUnfinalize}
            className="px-3 py-1 bg-green-600 text-white rounded"
          >
            Unfinalize
          </button>

        </div>

      </div>

    </div>
  );
};

export default UnfinalizeAttendance;